export const useSearchParamsWithType = (params) => {
  const { searchQuery, searchType, ...other } = params;

  return {
    ...(searchQuery
      ? {
          searchQuery,
        }
      : null),
    ...(searchQuery && searchType ? { searchType } : null),
    ...other,
  };
};
